module.exports = __webpack_public_path__ + "img/three2Blue.8720a8bf.png";